<script lang="ts">
	import { Table, type TableProps } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';

	export let props: TableProps;
	export let withRowsBorder: boolean;
	export let withLoadMoreActions: boolean;
	export let withSearch: boolean;
	export let columnIndexToSearch: number;
	export let searchPlaceholder: string;
	export let initialNumberDisplay: number;
	export let sticky: boolean;
	export let top;

	$: props.allFiltersLabel = $t('newsFeed.AllFilters');
	$: props.loadAllLabel = $t('loadAll');
	$: props.loadLessLabel = $t('loadLess');
</script>

<Table
	{props}
	{withRowsBorder}
	{withLoadMoreActions}
	{withSearch}
	{columnIndexToSearch}
	{searchPlaceholder}
	{initialNumberDisplay}
	{sticky}
	{top}
/>
